export default __webpack_public_path__ + "static/montserrat-v14-latin-700-99271a835e1cae8c76ef8bba99a8cc4e.woff";